<template>
  <div class="c-like icobutton" ref="like">
    <i ref="icon" class="download iconfont iconaixin" />
  </div>
</template>
<script>
import mojs from "@mojs/core";

export default {
  name: "CLike",
  props: {
    liked: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeline: new mojs.Timeline(),
      checked: false,
    };
  },
  computed: {
    isIOSSafari() {
      var userAgent;
      userAgent = window.navigator.userAgent;
      return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
    },
    isTouch() {
      var isIETouch;
      isIETouch =
        navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
      return [].indexOf.call(window, "ontouchstart") >= 0 || isIETouch;
    },
    clickHandler() {
      return this.isIOSSafari || this.isTouch ? "touchstart" : "click";
    },
  },
  methods: {
    init() {
      const like = this.$refs.like;
      const icon = this.$refs.icon;
      const opacityCurve = mojs.easing.path(
        "M0,0 L25.333,0 L75.333,100 L100,0"
      );
      const translationCurve = mojs.easing.path(
        "M0,100h25.3c0,0,6.5-37.3,15-56c12.3-27,35-44,35-44v150c0,0-1.1-12.2,9.7-33.3c9.7-19,15-22.9,15-22.9"
      );
      const squashCurve = mojs.easing.path(
        "M0,100.004963 C0,100.004963 25,147.596355 25,100.004961 C25,70.7741867 32.2461944,85.3230873 58.484375,94.8579105 C68.9280825,98.6531013 83.2611815,99.9999999 100,100"
      );
      this.timeline.add(
        new mojs.Burst({
          parent: like,
          opacity: 0.5,
          children: {
            duration: 1300,
            delay: 400,
            radius: { "rand(6,2)": 0 },
            fill: "#8028f5",
          },
          radius: { 20: 120 },
          degree: 60,
          angle: -30,
          count: 6,
          isRunLess: true,
          easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        })
      );
      this.timeline.add(
        new mojs.Burst({
          parent: like,
          shape: "circle",
          x: "-10px",
          children: {
            duration: 500,
            shape: "line",
            fill: "#ffffff",
            radius: { 20: 0 },
            stroke: "#ffffff",
            strokeWidth: 2,
            strokeLinecap: "round",
          },
          radius: { 20: 120 },
          angle: 180,
          count: 1,
          opacity: 0.4,
          isRunLess: true,
          easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        })
      );
      this.timeline.add(
        new mojs.Burst({
          parent: like,
          shape: "circle",
          y: "15px",
          children: {
            duration: 500,
            radius: { 20: 0 },
            shape: "line",
            fill: "#ffffff",
            stroke: "#ffffff",
            strokeWidth: 2,
            strokeLinecap: "round",
          },
          radius: { 20: 120 },
          angle: 180,
          count: 1,
          opacity: 0.4,
          isRunLess: true,
          easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        })
      );
      this.timeline.add(
        new mojs.Burst({
          parent: like,
          shape: "circle",
          x: "10px",
          children: {
            duration: 500,
            radius: { 20: 0 },
            shape: "line",
            fill: "#ffffff",
            stroke: "#ffffff",
            strokeWidth: 2,
            strokeLinecap: "round",
          },
          radius: { 20: 120 },
          angle: 180,
          count: 1,
          opacity: 0.4,
          isRunLess: true,
          easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
        })
      );
      this.timeline.add(
        new mojs.Tween({
          duration: 500,
          onUpdate: function (progress) {
            var translateProgress = translationCurve(progress),
              squashProgress = squashCurve(progress),
              scaleX = 1 - 2 * squashProgress,
              scaleY = 1 + 2 * squashProgress;
            icon.style.WebkitTransform = icon.style.transform =
              "translate3d(0," +
              -180 * translateProgress +
              "px,0) scale3d(" +
              scaleX +
              "," +
              scaleY +
              ",1)";
            var opacityProgress = opacityCurve(progress);
            icon.style.opacity = opacityProgress;
            like.style.color = progress >= 0.8 ? "inherit" : "#ffffff";
          },
        })
      );
    },
  },
  watch: {
    liked(liked) {
      if (liked) {
        this.timeline.play();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss">
.c-like {
  position: relative;

  i {
    display: block;
    font-size: inherit;
  }
}
</style>
